import axios from 'axios';

export function authHeader() {
  return { Authorization: `Bearer ${localStorage.getItem('token')}` };
}

const h = () => ({ headers: authHeader() });

export const rvApi = {
  groups: () => axios.get('/api/rules-violation/groups', h()),
  types: (groupId) => axios.get('/api/rules-violation/types', { ...h(), params: { groupId } }),
  properties: () => axios.get('/api/rules-violation/picker/properties', h()),
  locations: (propertyId) =>
    axios.get('/api/rules-violation/picker/locations', { ...h(), params: { propertyId } }),
  residents: (locationId) =>
    axios.get('/api/rules-violation/picker/residents', { ...h(), params: { locationId } }),
  context: (propertyId, locationId) =>
    axios.get('/api/rules-violation/context', {
      ...h(),
      params: { propertyId, locationId: locationId || undefined },
    }),
  previewNumber: (propertyId) =>
    axios.get('/api/rules-violation/preview-violation-number', { ...h(), params: { propertyId } }),
  createInspection: (body) => axios.post('/api/rules-violation/inspections', body, h()),
  getInspection: (id) => axios.get(`/api/rules-violation/inspections/${id}`, h()),
  patchInspection: (id, body) => axios.patch(`/api/rules-violation/inspections/${id}`, body, h()),
  submitInspection: (id, body) => axios.post(`/api/rules-violation/inspections/${id}/submit`, body, h()),
  addItem: (id, body) => axios.post(`/api/rules-violation/inspections/${id}/items`, body, h()),
  deleteItem: (id, itemId) => axios.delete(`/api/rules-violation/inspections/${id}/items/${itemId}`, h()),
  uploadInspectionPhoto: (id, file) => {
    const fd = new FormData();
    fd.append('image', file);
    return axios.post(`/api/rules-violation/inspections/${id}/photos`, fd, {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
    });
  },
  uploadItemPhoto: (id, itemId, file) => {
    const fd = new FormData();
    fd.append('image', file);
    return axios.post(`/api/rules-violation/inspections/${id}/items/${itemId}/photos`, fd, {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
    });
  },
  reports: (params) => axios.get('/api/rules-violation/reports', { ...h(), params }),
  reportItem: (itemId) => axios.get(`/api/rules-violation/reports/items/${itemId}`, h()),
  reportItemPdf: (itemId) =>
    axios.get(`/api/rules-violation/reports/items/${itemId}/pdf`, { ...h(), responseType: 'blob' }),
  adminGroups: () => axios.get('/api/rules-violation/admin/groups', h()),
  adminCreateGroup: (body) => axios.post('/api/rules-violation/admin/groups', body, h()),
  adminUpdateGroup: (id, body) => axios.put(`/api/rules-violation/admin/groups/${id}`, body, h()),
  adminDeleteGroup: (id) => axios.delete(`/api/rules-violation/admin/groups/${id}`, h()),
  adminTypes: (groupId) =>
    axios.get('/api/rules-violation/admin/types', { ...h(), params: { groupId } }),
  adminCreateType: (body) => axios.post('/api/rules-violation/admin/types', body, h()),
  adminUpdateType: (id, body) => axios.put(`/api/rules-violation/admin/types/${id}`, body, h()),
  adminDeleteType: (id) => axios.delete(`/api/rules-violation/admin/types/${id}`, h()),
};
